export enum Themes {
  Advantage = 'advantage',
  ANZ = 'anz',
  ASB = 'asb',
  Bendigo = 'bendigo',
  BoQ = 'boq',
  CMC = 'cmc',
  eBroking = 'ebroking',
  Rivkin = 'rivkin',
  StGeorge = 'stgeorge',
  SunCorp = 'suncorp',
  Supervision = 'supervision',
  Westpac = 'westpac',
  CMCAlpha = 'cmcinvestalpha',
  CMCSingapore = 'cmcinvestsingapore',
  ANZMola = 'mola',
  ANZCollateralise = 'collateraliseportal'
}

export const themesHaveMBLA = [Themes.CMC, Themes.Advantage, Themes.Rivkin];
export const themesCmc = [Themes.CMC, Themes.CMCAlpha];
